<!-- eslint-disable -->
<template lang="pug">
    .result-list
        .result-list__header(v-if="header")
            span.result-list__header-text(v-text="header")
            span.result-list__header-number(v-text="participantsNotSplitted.length")
        .result-list__winners-block
            .result-list__winner-place-block(v-for="(placeWinners, index) in winners" :style="borderColorForWinner(index)")
                .result-list__winner(v-for="winner in placeWinners")
                    .result-list__winner-place
                        .result-list__place(:style="colorForPlaceOfWinner(index)") {{ index + 1 }}
                    .result-list__winner-block
                        router-link.result-list__winner-profile(
                            v-if="canLinkToUser(winner)",
                            :to="{name: 'user:profile', params: {id: winner.id, type: 'student'}}",
                        )
                            img.result-list__winner-avatar(:src="winner.avatar")
                        .result-list__winner-profile(v-else)
                            img.result-list__winner-avatar(:src="winner.avatar")
                        .result-list__user-info
                            router-link.result-list__winner-name(
                                tag="div"
                                v-if="canLinkToUser(winner)",
                                :to="{name: 'user:profile', params: {id: winner.id, type: 'student'}}",
                            )
                                | {{ winner.fullName }}
                            .result-list__winner-name(v-else)
                                | {{ winner.fullName }}
                            .result-list__main-info
                                .result-list__winner-city
                                    svg-icon(name="pin" width="16")
                                    | {{ winner.city }}
                                .result-list__place-text-container
                                    svg-icon(name="coin" width="16")
                                    .result-list__pivot-container
                                        .result-list__pivot.result-list__pivot--winner
                                            | {{ ' (' + winner.pivot.points + ')' }} &nbsp;
                                        .result-list__pivot.result-list__pivot--winner
                                            | {{ getFormattedExecutionTime(winner.pivot.time) }}
        template(v-if="participantsWithoutWinners.length")
            .result-list__button-block
                cs-button.result-list__button(
                    narrow
                    color="blue"
                    pattern="primary-outline",
                    @click="showList = !showList"
                )
                    svg-icon(v-if="isLoaded", :name="iconName", middle)
                    span.result-list__button-text(v-text="showList ? $i18n.t('olympiads.olympiads_resultStudentList_hideAll') : $i18n.t('olympiads.olympiads_resultStudentList_showAll')")
            transition(
                name="slide",
                enterActiveClass="slide--enter-active",
                enterClass="slide--enter",
                enterToClass="slide--enter-to",
                leaveActiveClass="slide--leave-active",
                leaveClass="slide--leave",
                leaveToClass="slide--leave-to"
            )
                .result-list__students-block(v-show="showList")
                    .result-list__student-place-block(v-for="(placeParticipants, index) in participantsWithoutWinners")
                        .result-list__student(
                            v-for="(participant, participantIndex) in placeParticipants",
                            :class=`{
                                'result-list__student--last':
                                    participantIndex === placeParticipants.length - 1 && index === participantsWithoutWinners.length - 1
                            }`,
                            :key="participant.id"
                        )
                            .result-list__student-place
                                .result-list__place {{ index + 4 }}
                            .result-list__student-block
                                router-link.result-list__student-profile(
                                    v-if="canLinkToUser(participant)",
                                    :to="{name: 'user:profile', params: {id: participant.id, type: 'student'}}",
                                )
                                    img.result-list__student-avatar(:src="participant.avatar")
                                .result-list__student-profile(v-else)
                                    img.result-list__student-avatar(:src="participant.avatar")
                                .result-list__user-info
                                    router-link.result-list__student-name(
                                        tag="div"
                                        v-if="canLinkToUser(participant)",
                                        :to="{name: 'user:profile', params: {id: participant.id, type: 'student'}}",
                                    )
                                        | {{ participant.fullName }}
                                    .result-list__student-name(v-else)
                                        | {{ participant.fullName }}
                                    .result-list__main-info
                                        .result-list__student-city
                                            svg-icon(name="pin" width="16")
                                            | {{ participant.city }}
                                        .result-list__place-text-container
                                            svg-icon(name="coin" width="16")
                                            .result-list__pivot-container
                                                .result-list__pivot.result-list__pivot--student
                                                    | {{ ' (' + participant.pivot.points + ')' }} &nbsp;
                                                .result-list__pivot.result-list__pivot--student
                                                    | {{ getFormattedExecutionTime(participant.pivot.time) }}
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import {mapState} from 'vuex'
    import usersListMixin from "../../utils/user/usersListMixin"

    export default {
        mixins: [usersListMixin],
        props: {
            students: Array,
            header: String
        },
        data() {
            return {
                showList: false,
                isLoaded: true,
            }
        },
        methods: {
            getFormattedExecutionTime(seconds) {
                const SECONDS_IN_HOUR = 3600;
                const SECONDS_IN_MINUTE = 60;
                let hours = Math.floor(seconds / SECONDS_IN_HOUR);
                seconds -= hours * SECONDS_IN_HOUR;
                let minutes = Math.floor(seconds / SECONDS_IN_MINUTE);
                seconds -= minutes * SECONDS_IN_MINUTE;
                let timeObject = {seconds: seconds};
                let timeFormatString = 'ssс';
                if (hours || minutes) {
                    timeObject.minutes = minutes;
                    timeFormatString = 'mmм,' + timeFormatString;
                }
                if (hours) {
                    timeObject.hours = hours;
                    timeFormatString = 'hhч,' + timeFormatString;
                }
                return this.$moment(timeObject).format(timeFormatString);
            },
            borderColorForWinner (index) {
                let arrayOfColors = ['#FFAD1F', '#858585', '#A44020'];
                return 'border: 1px solid ' + arrayOfColors[index];
            },
            colorForPlaceOfWinner (index) {
                let arrayOfColors = ['#FF7245', '#858585', '#A44020'];
                return 'color: ' + arrayOfColors[index];
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            iconName() {
                return this.showList ? 'small-angle-up' : 'small-angle-down';
            },
            winners() {
                return this.participants.slice(0, 3);
            },
            participantsWithoutWinners() {
                return this.participants.slice(3);
            },
            participantsNotSplitted() {
                return this.students.filter((student) => {
                    return student.pivot.points || student.pivot.time;
                });
            },
            participants() {
                let flag = true;
                return this.participantsNotSplitted.reduce((acc, elem, index, array) => {
                    if (flag) {
                        acc.push([elem]);
                    }
                    if (
                            array[index + 1]
                            && elem.pivot.points === array[index + 1].pivot.points
                            && elem.pivot.time === array[index + 1].pivot.time
                    ) {
                        acc[acc.length - 1].push(array[index + 1]);
                        flag = false;
                    } else {
                        flag = true;
                    }
                    return acc;
                }, []);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .result-list__header {
        margin-bottom: 15px;
    }

    .result-list__header-text {
        font-size: 18px;
        font-weight: 500;
        margin-right: 10px;
    }

    .result-list__header-number {
        font-size: 18px;
        color: $hsl-color-gray-51;
    }

    .result-list__winner-place-block, .result-list__student-place-block {
        border-radius: 8px;
        margin-bottom: 10px;
        padding: 15px;
    }

    .result-list__student-place-block {
        border: 1px solid $hsl-color-gray-88;
    }

    .result-list__winner, .result-list__student {
        display: flex;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
            align-items: center;
        }
    }

    .result-list__winner-place, .result-list__student-place {
        @include media($md) {
            margin: 0 40px 0 30px;
        }
    }

    .result-list__student-place {
        color: $hsl-color-green-58;
    }

    .result-list__place {
        font-size: 24px;
        text-align: center;
        margin-bottom: 15px;
        @include media($md) {
            margin-bottom: 0;
        }
    }

    .result-list__winner-block, .result-list__student-block {
        display: flex;
        @include media($md) {
            width: 70%
        }
    }

    .result-list__user-info {
        @include media($md) {
            flex: 1 1 auto;
        }
    }

    .result-list__main-info {
        @include media($md) {
            display: flex;
            justify-content: space-between;
            flex: 1 1 auto;
        }
    }

    .result-list__winner-profile, .result-list__student-profile {
        display: flex;
    }

    .result-list__winner-avatar, .result-list__student-avatar {
        margin-right: 15px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        @include media($md) {
            width: 50px;
            height: 50px;
        }
        @media screen and (max-width: 767px) {
            position: absolute;
        }
    }

    .result-list__winner-name, .result-list__student-name {
        position: relative;
        color: $hsl-color-blue-56_5;

        @media screen and (max-width: 767px) {
            margin: 0 0 30px 60px;
        }
    }

    .result-list__winner-city, .result-list__student-city {
        display: flex;
        align-items: center;
        font-size: 13px;
        margin-bottom: 5px;
        .svg-icon {
            font-size: 16px;
            margin-right: 5px;
            color: $hsl-color-green-58;
        }
        @include media($md) {
            margin: 0 30px 0 0;
            align-items: flex-start;
            .svg-icon {
                margin: 2px 5px 0 0;
            }
        }
        @include media($xlg) {
            width: 60%
        }
    }

    .result-list__place-text-container {
        display: flex;
        align-items: center;
        .svg-icon {
            font-size: 16px;
            margin-right: 5px;
            color: $hsl-color-green-58;
        }
        @include media($md) {
            align-items: flex-start;
            .svg-icon {
                margin: 2px 5px 0 0;
            }
        }
    }

    .result-list__pivot-container {
        display: flex;
        font-size: 13px;
    }

    .result-list__button {
        margin: 20px auto;
        .svg-icon {
            margin-right: 5px;
        }
    }

    .slide--enter-active, .slide--leave-active {
        transition: max-height 1s;
        overflow: hidden;
    }
    .slide--enter, .slide--leave-to {
        max-height: 0;
    }
    .slide--enter-active, .slide--leave-active {
        .result-list__winner-avatar, .result-list__student-avatar {
            position: static;
        }
    }
    .slide--enter-to, .slide--leave {
        max-height: 400px;
    }
</style>
